module.exports = __webpack_public_path__ + "static/media/jammming.c75fc362.jpeg";